//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QRCode from 'qrcode'
import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';

import mainMenuTab from "@/components/mainMenuTab";

export default {
    components: {mainMenuTab,cardbox,navbar},
    data(){
        return {

            referData: {

            },
        }
    },
    methods:{

        // 查询推荐人列表
        initUserInfo(){

            const opts = {
                url: api.myReferrerList,
                data: {
                    page: 1,
                    size: 1,
                },
                type: 'get',
            }
            common.query(opts).then(res=>{
                this.referData = res.data;
            },res=>{
                this.$vux.toast.text(res.message);
            })

        },

        // 生成qrcode
        createQrcode(){

            const info = common.storageJson("userInfo") || {};

            const qrcode = QRCode.toCanvas(document.getElementById('qrcode'),`${location.origin}?referid=${info.user_id}`,{
                width: 260,
                margin: 2,
                color: {
                    dark: '#34a600ff',
                    light: '#ffffff'
                }
            });
        },

    },
    mounted(){

        this.initUserInfo();
        this.createQrcode();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/distribution.vue